import { usePwaPrompt } from './usePwaPrompt';

export const PwaPrompt = () => {
	usePwaPrompt();

	return null;
};
